let keys: {
  Locations: string
  Logs: string
  Users: string
  Contacts: string
  Audit: string
  Opportunities: string
  Conversations: string
  Companies: string
  SocialMediaService: string
  AffiliateManager: string
  CustomEmails: string
  EmailISV: string
  Wordpress: string
  Onboarding: string
  Oauth: string
  Integrations: string
  Platform: string
  Business: string
  Calendar: string
  Campaigns: string
  Notification: string
  Links: string
  Urls: string
  Leadconnector: string
  Hooks: string
  InternalTools: string
  SaaS: string
  SaaSBilling: string
  EmailReporting: string
  CallsReporting: string
  SMSReporting: string
  Templates: string
  AppEngine: string
  Yext: string
  Sockets: string
  PhoneSystem: string
} = {}

export const override = false

if (
  override ||
  process.env.NODE_ENV === 'production' ||
  process.env.NODE_ENV === 'beta'
) {
  keys = {
    Audit: 'https://services.leadconnectorhq.com/logs/audit',
    CustomEmails: 'https://services.leadconnectorhq.com/email-auth',
    Locations: 'https://services.leadconnectorhq.com/locations',
    Logs: 'https://services.leadconnectorhq.com/logs',
    Users: 'https://services.leadconnectorhq.com/users',
    Contacts: 'https://services.leadconnectorhq.com/contacts',
    Opportunities: 'https://services.leadconnectorhq.com/opportunities',
    Conversations: 'https://services.leadconnectorhq.com/conversations',
    Companies: 'https://services.leadconnectorhq.com/companies',
    SocialMediaService: 'https://services.leadconnectorhq.com/social-media-posting',
    Wordpress: 'https://services.leadconnectorhq.com/wordpress',
    EmailISV: 'https://services.leadconnectorhq.com/email-isv',
    Platform: 'https://services.leadconnectorhq.com/platform',
    Onboarding: 'https://services.leadconnectorhq.com/onboarding',
    Oauth: 'https://services.leadconnectorhq.com/oauth',
    Business: 'https://services.leadconnectorhq.com/businesses',
    Integrations: 'https://services.leadconnectorhq.com/integrations',
    Calendar: 'https://services.leadconnectorhq.com/calendars',
    Campaigns: 'https://services.leadconnectorhq.com/campaigns',
    AffiliateManager: 'https://services.leadconnectorhq.com/affiliate-manager',
    Notification: 'https://services.leadconnectorhq.com/notifications',
    Links: 'https://services.leadconnectorhq.com/links',
    Urls: 'https://services.leadconnectorhq.com/urls',
    Leadconnector: 'https://services.leadconnectorhq.com/leadconnector',
    InternalTools: 'https://services.leadconnectorhq.com/internal-tools',
    SaaS: 'https://services.leadconnectorhq.com/saas_service',
    SaaSBilling: 'https://services.leadconnectorhq.com/saas_billing',
    EmailReporting: 'https://services.leadconnectorhq.com/reporting/emails',
    CallsReporting: 'https://services.leadconnectorhq.com/reporting/calls',
    SMSReporting: 'https://services.leadconnectorhq.com/reporting/sms',
    Templates: 'https://services.leadconnectorhq.com/templates',
    AppEngine: 'https://services.leadconnectorhq.com/appengine',
    Yext: 'https://services.leadconnectorhq.com/yext',
    Sockets: 'https://services.leadconnectorhq.com',
    PhoneSystem: 'https://services.leadconnectorhq.com/phone-system',
    Hooks: 'https://services.leadconnectorhq.com/hooks'
  }
  if (process.env.NODE_ENV === 'beta') {
    keys.Contacts = 'https://beta.services.msgsndr.com/contacts'
    keys.Opportunities = 'https://beta.services.msgsndr.com/opportunities'
    keys.Conversations = 'https://beta.services.msgsndr.com/conversations'
    keys.Oauth = 'https://beta.services.msgsndr.com/oauth'
    keys.Locations = 'https://beta.services.msgsndr.com/locations'
    keys.Users = 'https://beta.services.msgsndr.com/users'
    keys.Integrations = 'https://beta.services.msgsndr.com/integrations'
    keys.Leadconnector = 'https://services.leadconnectorhq.com/leadconnector'
    keys.SaaS = 'https://services.leadconnectorhq.com/saas_service'
    keys.SaaSBilling = 'https://services.leadconnectorhq.com/saas_billing'
    keys.PhoneSystem = 'https://services.leadconnectorhq.com/phone-system'
  }
} else if (
  process.env.NODE_ENV === 'staging' ||
  process.env.NODE_ENV === 'development' ||
  process.env.NODE_ENV === 'test'
) {
  keys = {
    Audit: 'https://staging.services.leadconnectorhq.com/logs/audit',
    CustomEmails: 'https://staging.services.leadconnectorhq.com/email-auth',
    Locations: 'https://staging.services.leadconnectorhq.com/locations',
    Logs: 'https://staging.services.leadconnectorhq.com/logs',
    Users: 'https://staging.services.leadconnectorhq.com/users',
    Contacts: 'https://staging.services.leadconnectorhq.com/contacts',
    Opportunities: 'https://staging.services.leadconnectorhq.com/opportunities',
    Conversations: 'https://staging.services.leadconnectorhq.com/conversations',
    Companies: 'https://staging.services.leadconnectorhq.com/companies',
    SocialMediaService:
      'https://staging.services.leadconnectorhq.com/social-media-posting',
    EmailISV: 'https://staging.services.leadconnectorhq.com/email-isv',
    Wordpress: 'https://staging.services.leadconnectorhq.com/wordpress',
    Onboarding: 'https://staging.services.leadconnectorhq.com/onboarding',
    Oauth: 'https://staging.services.leadconnectorhq.com/oauth',
    Business: 'https://staging.services.leadconnectorhq.com/businesses',
    Integrations: 'https://staging.services.leadconnectorhq.com/integrations',
    Platform: 'https://staging.services.leadconnectorhq.com/platform',
    Calendar: 'https://staging.services.leadconnectorhq.com/calendars',
    Campaigns: 'https://staging.services.leadconnectorhq.com/campaigns',
    AffiliateManager:
      'https://staging.services.leadconnectorhq.com/affiliate-manager',
    Notification: 'https://staging.services.leadconnectorhq.com/notifications',
    Links: 'https://staging.services.leadconnectorhq.com/links',
    Urls: 'https://staging.services.leadconnectorhq.com/urls',
    Leadconnector: 'https://staging.services.leadconnectorhq.com/leadconnector',
    InternalTools:
      'https://staging.services.leadconnectorhq.com/internal-tools',
    SaaS: 'https://staging.services.leadconnectorhq.com/saas_service',
    SaaSBilling: 'https://staging.services.leadconnectorhq.com/saas_billing',
    EmailReporting:
    'https://staging.services.leadconnectorhq.com/reporting/emails',
    CallsReporting:
    'https://staging.services.leadconnectorhq.com/reporting/calls',
    SMSReporting: 'https://staging.services.leadconnectorhq.com/reporting/sms',
    Templates: 'https://staging.services.leadconnectorhq.com/templates',
    AppEngine: 'https://staging.services.leadconnectorhq.com/appengine',
    Yext: 'https://staging.services.leadconnectorhq.com/yext',
    Sockets: 'https://staging.services.leadconnectorhq.com',
    PhoneSystem: 'https://staging.services.leadconnectorhq.com/phone-system',
    Hooks: 'https://staging.services.leadconnectorhq.com/hooks'
  }
  if (process.env.NODE_ENV === 'development') {
    // keys.Locations = 'http://localhost:5056/locations',
    // keys.Contacts = 'http://localhost:5058/contacts'
    // keys.Opportunities = 'http://localhost:5066/opportunities'
    // keys.Conversations = 'http://localhost:5063/conversations'
    // keys.Companies = 'http://localhost:5079/companies'
    // keys.CustomEmails = 'http://localhost:5084/email-auth'
    // keys.SocialMedia = 'http://localhost:7020/social-media-posting',
    // keys.EmailISV = 'http://localhost:5083/email-isv',
    // keys.Onboarding = 'http://localhost:5086/onboarding'
    // keys.Oauth = 'http://localhost:5062/oauth';
    // keys.Integrations = 'http://localhost:5059/integrations'
    // keys.Calendar: 'http://localhost:5080/calendars',
    // keys.Campaigns: 'http://localhost:5069/campaigns',
    // keys.AffiliateManager = 'http://localhost:5086/affiliate-manager'
    // keys.Notification = 'http://localhost:5082/notifications'
    // keys.Business="http://localhost:5099/businesses"
    // keys.Urls = 'http://localhost:5099/urls'
    // keys.Links= 'http://localhost:5073/links'
    // keys.Leadconnector = 'http://localhost:6050'
    // keys.Users = 'http://localhost:5065/users'
    // keys.InternalTools = 'http://localhost:5103/internal-tools'
  }
}

/**
 * To use a versioned deployment, specify the value in the below versions object.
 *
 * key: className which extends BaseService
 * value: <version_value> : string
 *
 * If this is specified here, it will overwrite the default baseUrl
 * & route the requests to the versioned deployment
 *
 * Versioned deployments will be auto-deleted after 7 days from the date of latest deployment
 *
 */

export const versions = {
  // PlatformService: 'naman28120230',
  // 'CalendarService' : 'anand',
  //'CompanyService' : 'yogi2612',
  //'ContactService' : 'ansh2512',
  //'ConversationChannelService': 'swapnil',
  //'ConversationsService' : 'justin',
  //'IntegrationsServices' : 'gaurav01',
  //'NotificationService' : 'naman27dec',
  // CallsReportingService: 'call-metrics',
  // SMSReportingService: 'sms-reporting',
  // SocialMediaService: 'mayur-i18n'
}

export default keys
